/** Link at proofread API endpoint (temporary use circulation API for mock) */
const apiProofread = proofreadId => `/api/services/circulation/${proofreadId ? `${proofreadId}/` : ""}`;

const apiCreateOrder = "/api/services/circulation/create_and_send/";
const apiFetchCost = "/api/services/circulation/cost/";
const apiFetchEditionCost = "/api/services/circulation/cost/";

const apiSendToModeration = circulationId => `/api/services/circulation/${circulationId}/send/`;

const apiCirculation = circulationId => {
  const id = circulationId ? `${circulationId}/` : "";
  return `/api/services/circulation/${id}`;
};

const apiProofreadOrderSave = "/api/services/service/";
export { apiProofread, apiCreateOrder, apiFetchCost, apiFetchEditionCost, apiSendToModeration, apiCirculation, apiProofreadOrderSave };